export default {
  Actions: {
    FETCH_GOALS_SUCCESS: 'goals/FETCH_GOALS_SUCCESS',
    CREATE_GOAL_SUCCESS: 'goals/CREATE_GOAL_SUCCESS',
    FETCH_SINGLE_GOAL_SUCCESS: 'goals/FETCH_SINGLE_GOAL_SUCCESS',
    MOVE_GOAL_SUCCESS: 'goals/MOVE_GOAL_SUCCESS',
    MOVE_GOAL_WITHOUT_REQUEST_SUCCESS: 'goals/MOVE_GOAL_WITHOUT_REQUEST_SUCCESS',
    MARK_GOAL_COMPLETE_SUCCESS: 'goals/MARK_GOAL_COMPLETE_SUCCESS',
    MARK_GOAL_COMPLETE_AND_ACTION_ITEMS_COMPLETE_SUCCESS: 'goals/MARK_GOAL_COMPLETE_AND_ACTION_ITEMS_COMPLETE_SUCCESS',
    MARK_GOAL_INCOMPLETE_SUCCESS: 'goals/MARK_GOAL_INCOMPLETE_SUCCESS',
    CHANGE_STATUS_SUCCESS: 'goals/CHANGE_STATUS_SUCCESS',
    UPDATE_ACTION_ITEM_ORDER_PREREQUEST: 'goals/UPDATE_ACTION_ITEM_ORDER_PREREQUEST',
    UPDATE_GOAL_SUCCESS: 'goals/UPDATE_GOAL_SUCCESS',
    DELETE_GOAL_SUCCESS: 'goals/DELETE_GOAL_SUCCESS',
  },
  State: {
    GOALS_BY_GOAL_SLUG: 'GOALS_BY_GOAL_SLUG',
  },
};
